export const isSafari = () => {
    const ua = navigator.userAgent;
    return /Safari/.test(ua) && !/Chrome|Chromium/.test(ua) && navigator.vendor === 'Apple Computer, Inc.';
};

export const registerStyleSheet = (styleCode: string, id?: string) => {
    const style = document.createElement('style');
    style.innerHTML = styleCode;
    if (id) {
        style.id = id;
    }
    document.body.appendChild(style);
    const remove = () => {
        document.body.removeChild(style);
    };
    return remove;
};

export const copy2Clipboard = (text: string) =>
    new Promise<{ success: boolean; error?: Error }>((resolve) => {
        // safari的复制api不能在promise内部调用
        setTimeout(() => {
            navigator.clipboard
                .writeText(text)
                .then(() => resolve({ success: true }))
                .catch((error) => {
                    console.error('===[copy2Clipboard] error: ', error);
                    resolve({ success: false, error });
                });
        });
    });

/** 检查是否处于beforeunload的时机之后 (防止safari中断请求导致报错并继续执行catch逻辑) */
export const checkIsBeforeUnload = (() => {
    let isBeforeUnload = false;
    if (typeof window !== 'undefined') {
        window.addEventListener('beforeunload', () => {
            isBeforeUnload = true;
        });
    }
    return () => isBeforeUnload;
})();

/**
 * 判断是否是平板设备（SSR 安全）
 */
export const isPad = () => {
    // SSR 环境（无 window/navigator/screen）
    if (typeof window === 'undefined' || typeof navigator === 'undefined' || typeof screen === 'undefined') {
        return true; // SSR 下默认返回 true
    }

    const ua = navigator.userAgent.toLowerCase();
    const maxTouch = navigator.maxTouchPoints || 0;
    const dpr = window.devicePixelRatio || 1;
    const width = Math.min(window.screen.width, window.screen.height);

    // 1. iPad / iPadOS（iPadOS 13+ 会伪装成 Mac）
    if (/ipad/.test(ua) || (/macintosh/.test(ua) && maxTouch > 1)) {
        return true;
    }

    // 2. Android 平板（非手机）
    if (/android/.test(ua) && !/mobile/.test(ua)) {
        return true;
    }

    // 3. Windows / Linux / X11 平板（触屏设备）
    if ((/windows/.test(ua) || /linux/.test(ua) || /x11/.test(ua)) && maxTouch > 1) {
        // 增加 DPI 判断：一般平板 >= 1.5，触屏电脑多为 1.0~1.25
        const isHighDPI = dpr >= 1.5;
        // 宽度小于 1280 且高 DPI 视作平板，否则视作触屏电脑
        return width < 1280 && isHighDPI;
    }

    return false;
};
